import PostCard from 'components/PostCard';
import { Heading2 } from 'elements/Typography';
import PropTypes from 'prop-types';

const RelatedPosts = ({ posts }) => (
  <>
    {posts && posts.length >= 1 && (
      <>
        <div className="mt-12 text-center md:mx-auto md:max-w-2xl">
          <Heading2 as="h3" className="text-grey-10">
            Related Articles
          </Heading2>
        </div>
        <div className="mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">
          {posts.map(({ node }) => (
            <PostCard
              key={node.id}
              id={node.id}
              slug={node.slug}
              featuredImage={node.featuredImage}
              categories={node.categories}
              title={node.title}
              author={node.author}
              date={node.date}
            />
          ))}
        </div>
      </>
    )}
  </>
);

RelatedPosts.propTypes = {
  posts: PropTypes.array.isRequired,
};

export default RelatedPosts;
